// extracted by mini-css-extract-plugin
export default {"row":"resend-row_row__0hqaP","row-disabled":"resend-row_row-disabled__b90fK","icon":"resend-row_icon__dnz4G","text":"resend-row_text__Re9Kk","button":"resend-row_button__vWgUW"};